export const mapReportsChartPoints = (chart) => {
  const sourceChart = chart && typeof chart === 'object' ? chart : {};
  const points = Array.isArray(sourceChart.points) ? sourceChart.points : [];

  if (points.length > 0) {
    return points.map((point, index) => ({
      label: String(point?.x || point?.label || `P${index + 1}`).trim() || `P${index + 1}`,
      value: Number(point?.y ?? point?.value ?? 0),
    }));
  }

  const x = Array.isArray(sourceChart.x) ? sourceChart.x : [];
  const y = Array.isArray(sourceChart.y) ? sourceChart.y : [];
  const size = Math.max(x.length, y.length);

  return Array.from({ length: size }).map((_, index) => ({
    label: String(x[index] || `P${index + 1}`).trim() || `P${index + 1}`,
    value: Number(y[index] || 0),
  }));
};
